<div class="spinner__pro" *ngIf="(isLoadingNextOp | async) || (isProcessRestarted | async) || (isLoading | async)">
  <div class="spinner__pro--content">
    <div *ngIf="(isLoading | async) || (isProcessRestarted | async)">
      <div class="spinner__pro--circle"></div>
      <mat-icon>lock_outline</mat-icon>
      <span class="spinner__pro--text">{{ 'signaturit_pro.loading.loading_message' | translate:_transParam }}</span>
    </div>
    <div *ngIf="isLoadingNextOp | async">
      <img class="spinner__pro--op-icon" [src]="operation.icon" alt="operation-icon"/>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <span class="spinner__pro--text spinner__pro--op-text" [innerHtml]="operation.text | translate"></span>
    </div>
  </div>
</div>
